import React, { useState, useEffect } from 'react';
import HeroImage from '../../assets/images/hero.png';
import HeroMobileImage from '../../assets/images/hero_mob.png';
import BookingModal from './BookingModal';

const Hero = () => {
    const [showBookingModal, setShowBookingModal] = useState(false);
    const [isMobile, setIsMobile] = useState(false);
    const language = localStorage.getItem('language') || 'en';

    // Check if device is mobile
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 426); // You can adjust this breakpoint
        };

        // Check on mount
        checkMobile();

        // Add event listener for window resize
        window.addEventListener('resize', checkMobile);

        // Cleanup
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const menuCategories = [
        'North Indian',
        'South Indian',
        'Indo-Chinese',
        'Vegetarian',
        'Vegan Options',
        'Weekly Meal Plans',
        'Corporate Plans'
    ];

    return (
        <>
            <section
                id="home"
                className="relative w-full cursor-pointer"
                style={{
                    height: '100vh',
                    paddingTop: '64px' // Add padding instead of margin to account for header
                }}
                onClick={() => setShowBookingModal(true)}
            >
                {/* Main image - switches based on screen size */}
                <div
                    className="w-full cursor-pointer"
                    style={{
                        height: 'calc(100vh - 64px)', // Full viewport minus header
                        backgroundImage: `url(${isMobile ? HeroMobileImage : HeroImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center center',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                </div>
            </section>

            {/* Booking Modal */}
            <BookingModal
                isOpen={showBookingModal}
                onClose={() => setShowBookingModal(false)}
                menuCategories={menuCategories}
                language={language}
            />
        </>
    );
};

export default Hero;